import React from 'react'
import DropdownSelectButton from './DropdownSelectButton'
import IconLabel from './IconLabel'

export interface IDropdownSelectItem {
  id: string
  onClick?: () => void
  icon?: string
  children: JSX.Element | string
}

interface IProps {
  className?: string
  buttonClassName?: string
  items: IDropdownSelectItem[]
  id: string
  labelContent?: string | JSX.Element
  selectedItemId: string
  onChange: (id: string) => void
}

class DropdownSelect extends React.Component<IProps> {
  public render(): JSX.Element {
    const {
      buttonClassName,
      id,
      className,
      items,
      labelContent,
      selectedItemId
    } = this.props

    return (
      <div className={`dropdown ${className}`}>
        {labelContent && <label htmlFor={id}>{labelContent}</label>}
        <button
          className={`btn btn-secondary dropdown-toggle ${buttonClassName}`}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          id={id}
        >
          {items.map(
            (item: IDropdownSelectItem): JSX.Element => (
              <span
                key={item.id}
                className={item.id === selectedItemId ? '' : 'Hidden'}
              >
                <IconLabel icon={item.icon} label={item.children} />
              </span>
            )
          )}
        </button>
        <div className="dropdown-menu" aria-labelledby={id}>
          <div className="row">
            <div className="col">
              {items.map(
                (item: IDropdownSelectItem): JSX.Element => (
                  <DropdownSelectButton
                    key={item.id}
                    onClick={(): void => this.props.onChange(item.id)}
                    {...item}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DropdownSelect
